<h5 class="ds-body ds-color--black mt-4 mb-4 mt-lg-0">{{'leadForm.sections.contractDetails' | cxTranslate}}</h5>
<ng-container *ngIf="userType">
  <form [formGroup]="contractDetailsForm">
    <ds-input #expectedTotalValue
              [label]="'leadForm.fields.expectedTotalValue.label' | cxTranslate"
              [placeholder]="'leadForm.fields.expectedTotalValue.label' | cxTranslate"
              [showErrorMessages]="submitted"
              [tooltipContent]="'leadForm.fields.expectedTotalValue.tooltipContent' | cxTranslate"
              class="mt-3"
              dcpWhitespaceOnly
              formControlName="expectedTotalValue"
              required
              type="text">
      >
    </ds-input>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(expectedTotalValue, 'required') || hasValidationFailed(expectedTotalValue, 'whitespaceOnly')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.number' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(expectedTotalValue, 'numberFormat') && !hasValidationFailed(expectedTotalValue, 'required') && !hasValidationFailed(expectedTotalValue, 'whitespaceOnly')">
    </ds-input-error>
    <ng-container *ngIf="currencies$ | async as currencies">
      <ng-container *ngIf="currencies && currencies.length">
        <div class="order-xl-2 mt-2" data-cy="currency">
          <ds-combo-box #currency
                        (valueChange)="onCurrencyChange($event)"
                        [label]="'leadForm.fields.currency' | cxTranslate"
                        [multiselect]="false"
                        [showErrorMessages]="submitted"
                        class="mt-4"
                        formControlName="currency">
            <ds-combo-box-dropdown #singleCombo [initialValue]="['1']" [multiselect]="false">
              <ds-combo-box-dropdown-group maxHeight="12.5rem">
                <ds-combo-box-dropdown-option
                  *ngFor="let currency of currencies"
                  [displayCheckbox]="false"
                  [label]="currency.isocode"
                  [value]="currency.isocode">
                  <span [innerHTML]="currency.isocode | textSearchHighlight:singleCombo.searchInput"></span>
                </ds-combo-box-dropdown-option>
              </ds-combo-box-dropdown-group>
            </ds-combo-box-dropdown>
          </ds-combo-box>
          <ds-input-error
            [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
            [showError]="hasValidationFailed(currency.formControl, 'required')">
          </ds-input-error>
        </div>
      </ng-container>
    </ng-container>
    <ds-date-picker
      #datePickerStartDate
      [label]="'leadForm.fields.expectedStartDate' | cxTranslate"
      [readOnlyLabel]="('leadForm.fields.expectedStartDate' | cxTranslate) + ('common.colon' | cxTranslate)"
      [showErrorMessages]="submitted"
      class="max-field-size mt-4"
      formControlName="rangeStart"
      placeholder="dd-MMM-yyyy"
      required
    >
    </ds-date-picker>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(datePickerStartDate, 'required')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.invalidDate' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(datePickerStartDate, 'format') && !hasValidationFailed(datePickerStartDate, 'required')">
    </ds-input-error>
    <ds-input-error
      [error]="{
                    message: 'leadForm.errors.startDate'
                      | cxTranslate : {
                            minDate: getErrorDate('rangeEnd')
                      },
                    iconClass: 'ds-icon--close-outline'
                  }"
      [showError]="hasValidationFailed(contractDetailsForm, 'range') && !hasValidationFailed(datePickerStartDate, 'format') && !hasValidationFailed(datePickerStartDate, 'required')">
    </ds-input-error>
    <ds-date-picker
      #datePickerEndDate
      [label]="'leadForm.fields.expectedEndDate' | cxTranslate"
      [readOnlyLabel]="('leadForm.fields.expectedEndDate' | cxTranslate) + ('common.colon' | cxTranslate)"
      [showErrorMessages]="submitted"
      class="max-field-size mt-4"
      formControlName="rangeEnd"
      placeholder="dd-MMM-yyyy"
      required
    >
    </ds-date-picker>
    <ds-input-error
      [error]="{message: 'leadForm.errors.required' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(datePickerEndDate, 'required')">
    </ds-input-error>
    <ds-input-error
      [error]="{message: 'leadForm.errors.invalidDate' | cxTranslate, iconClass:'ds-icon--close-outline'}"
      [showError]="hasValidationFailed(datePickerEndDate, 'format') && !hasValidationFailed(datePickerEndDate, 'required')">
    </ds-input-error>
    <ds-input-error
      [error]="{
                    message: 'leadForm.errors.endDate'
                      | cxTranslate : {
                            maxDate: getErrorDate('rangeStart')
                      },
                    iconClass: 'ds-icon--close-outline'
                  }"
      [showError]="hasValidationFailed(contractDetailsForm, 'range') && !hasValidationFailed(datePickerEndDate, 'format') && !hasValidationFailed(datePickerEndDate, 'required')">
    </ds-input-error>
  </form>
</ng-container>
